<template>
  <!--头部 -->
  <div id="head">
    <div class="head">
      <div class="head_left">
        <span>大学生企业推荐</span>
      </div>
      <div class="head_center">
        <span
          :class="
            $route.path === '/home' || $route.path === '/' ? 'botton_line' : ''
          "
          @click="$router.push('/home')"
          >首页</span
        >
        <span
          :class="$route.path === '/searchCenter' ? 'botton_line' : ''"
          @click="$router.push('/searchCenter')"
          >搜索中心</span
        >

        <span
          :class="$route.path === '/resume' ? 'botton_line' : ''"
          @click="$router.push('/resume')"
          >简历</span
        >
        <span
          :class="$route.path === '/interview' ? 'botton_line' : ''"
          @click="$router.push('/interview')"
          >面试</span
        >
        <span
          :class="$route.path === '/record/browse' ? 'botton_line' : ''"
          @click="$router.push('/record/browse')"
          >历史记录</span
        >
        <span @click="skipEnterpriseEdition()">我要招人</span>
      </div>
      <div class="head_right">
        <div
          class="no_login"
          @click="changeLoginBox(true)"
          v-if="this.$store.state.isShowTopBarNoLoginBox"
        >
          <span @click="changeDefaultLoginState(true)">登录</span>
          <span>|</span>
          <span @click="changeDefaultLoginState(false)">注册</span>
        </div>
        <div class="logined" v-else>
          <div class="logined_left">
            <el-badge
              :value="$store.state.msgSum"
              :max="99"
              :hidden="$store.state.msgSum == 0"
              class="item"
            >
              <span @click="$router.push('/messageCenter')">消息</span>
            </el-badge>

            <span @click="$router.push('/record')"> 收藏</span>
          </div>
          <div>|</div>
          <div class="logined_right">
            <!-- <img src="@/assets/images/touxiang.png" alt="" /> -->
            <img :src="this.$store.state.userImg" alt="" />
            <span>{{ this.$store.state.userName }}</span>
            <div>
              <div @click="$router.push('/personalCenter')">个人中心</div>
              <div @click="outLogin()">退出登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { MessageBox } from "element-ui";
import { DeleteTokenAPI } from "@/request/token/api";

import { WebSocketSingleton as webSocket } from "@/utils/websocket";

import { Enterprise_API_URL } from "@/utils/url";
export default {
  data() {
    return {};
  },
  methods: {
    ...mapMutations([
      "changeLoginBox",
      "changeTopBarNoLoginBox",
      "changeDefaultLoginState",
    ]),

    outLogin() {
      MessageBox.confirm("确认退出登录？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.changeLoginBox(true);
          this.changeTopBarNoLoginBox(true);
          localStorage.removeItem("user-id");
          localStorage.removeItem("user-img");
          localStorage.removeItem("user-nickname");
          localStorage.removeItem("user-fillState");
        
          DeleteTokenAPI(localStorage.getItem("user-token"));
          setTimeout(() => {
            //延迟删除防止请求发送时没用token
            localStorage.removeItem("user-token");
            webSocket.close();
          }, 200);
    
        
 
        })
        .catch(() => {});
    },
    skipEnterpriseEdition() {
      window.open(Enterprise_API_URL, "_blank");
    },
  },
};
</script>

<style scoped>
.botton_line {
  border-bottom: 4px solid #fff;
  pointer-events: none;
}
span {
  cursor: pointer;
}

input {
  outline: none;
  background: transparent;
  border: none;
  outline: medium;
}

#head {
  height: 40px;
  padding: 5px 0;
  background-color: #24adde;
  min-width: 1200px;
  margin-bottom: 10px;
}

.head {
  display: flex;
  margin: auto;
  justify-content: space-between;
  height: 40px;
  width: 1200px;
}

.head_left {
  width: 200px;
  height: 40px;

  text-align: center;
  line-height: 40px;
  font-size: 20px;
  color: #fff;
}

.head_right {
  width: 250px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: #fff;
}

.no_login {
  display: flex;
}

.no_login > span:nth-child(2) {
  margin: 0 10px;
}

.logined {
  display: flex;
  justify-content: space-between;
}

.logined > div:nth-child(2) {
  margin: 0 10px;
}

.logined_left {
  width: 100px;
}

.logined_right {
  display: flex;
  width: 150px;
  position: relative;
}

.logined_left span {
  padding: 10px 2px;
}

.logined_right span {
  height: 40px;

  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.logined_right img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  vertical-align: middle;
}
.logined_right > div > div {
  cursor: pointer;
}
.logined_right > div {
  position: absolute;
  display: none;
  text-align: center;
  top: 40px;
  width: 150px;
  height: 120px;
  background-color: white;
  box-shadow: 0 2px 5px #eee;
}

.logined_right:hover > div {
  z-index: 2;
  display: block;
}

.logined_right > div > div:hover {
  color: #24adde;
  background-color: #f8f8f8;
}

.logined_right > div > div {
  color: #0c0b0b;
}

.head_center {
  display: flex;
  width: 700px;
  height: 40px;
}

.head_center span {
  flex-grow: 1;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: #fff;
}

.head_center span:hover {
  border-bottom: 4px solid #fff;
}
</style>